module.exports = __webpack_public_path__ + "static/media/alert-circle.4b5cb56f.svg";